import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import * as OfficeContracts from './Saga/OfficeContracts';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,

} from '@material-ui/pickers';

// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';

// import DatePicker from "react-datepicker";
// const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  formData: any,
  rent_contracts_list: any,
  change_formData: any,
  search_rent_contracts_list: any,
  get_rent_contracts_list: any,
  // get_rent_contracts: any,
  // change_search_name: any,
  // change_search_contract_date_start: any,
  // change_search_contract_date_end: any,
  // search_contract_date_start: any,
  // search_contract_date_end: any,
  // change_search_tatemono_name: any,
  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string
}



interface State {
  reflash: any,
}


const pay_list =[
  {id:0, value:"　"},
  {id:1, value:"振込"},
  {id:2, value:"カード"},
  {id:3, value:"口座振替"}]

const headers = [
    { label: "賃貸革命", key: "bk_no_name" },
    { label: "申込日", key: "application_date_format" },
    { label: "契約日", key: "contract_date_format" },
    { label: "契約者", key: "contractor_name1" },
    { label: "契約者カナ", key: "contractor_kana1" },
    { label: "駐車場名", key: "building_name" },
    { label: "号", key: "room_name" },
    { label: "契約締結日", key: "cloudsign_completed_at_format" },
    { label: "支払日", key: "payment_date_format" },
    { label: "支払区分", key: "payment_type_name" },
    { label: "支払予定区分", key: "apply_payment_type_name" },
    { label: "月々支払区分", key: "month_payment_type_name" },
    { label: "クレジット登録日", key: "credit_entry_at_format" },
    { label: "契約金", key: "contract_money" },
    { label: "キャンセル日", key: "cancel_date_format" },


  ];

class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      reflash: false,

    };
    // this.props.change_search_name("")
    // this.props.change_search_contract_date_start(new Date())
    // this.props.change_search_contract_date_end(null)
    // this.change_search_name = this.change_search_name.bind(this);

    // this.handleContractionDateChange = this.handleContractionDateChange.bind(this);
    // this.handleContractionDateChangeEnd = this.handleContractionDateChangeEnd.bind(this);

    // this.change_search_tatemono_name = this.change_search_tatemono_name.bind(this);

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }

  onClear = () => {
    // alert(event.target.name)

    let formData = this.props.formData
    formData.chinkaku_mi = true
    formData.chinkaku_zumi = false
    formData.application_date_start = null
    formData.application_date_end = null
    formData.contract_date_start = moment().add(-1, "years").startOf('month').format("YYYY-MM-DD")
    formData.contract_date_end = null
    formData.contractor_name1 = ""
    formData.building_name = ""
    formData.cloudsign_completed_at_start = null
    formData.cloudsign_completed_at_end = null
    formData.payment_type = []
    formData.apply_payment_type = []
    formData.month_payment_type = []
    formData.cancel_date_start = moment().add(-7, "days").format("YYYY-MM-DD")
    formData.cancel_date_end = null
    formData.cancel_only = false

    this.props.change_formData(formData);
    
    this.props.get_rent_contracts_list()

    this.setState({ reflash: !this.state.reflash });
}

  handleChange = (event:any) => {
    // alert(event.target.name)
    console.log(event)

    let formData = this.props.formData


    if (event.target.name === "chinkaku_mi" || event.target.name === "chinkaku_zumi" || event.target.name === "cancel_only" || event.target.name === "chinkaku_zumi_henkou") {
        formData[event.target.name] = event.target.checked

    } else if (event.target.name === "condition_radio") {
        formData[event.target.name] = event.target.value;
        if (event.target.value == 0) {
            formData["response_date_start"] = ""
        }else if (event.target.value == 1) {
            // formData["response_date_start"] = moment().add(-3, "months").format("YYYY-MM-DD")
        }

    } else if (event.target.name === "jyukenyotei" || event.target.name === "condition") {

        if (event.target.checked) {
            let ary = formData[event.target.name] ? formData[event.target.name].split(",") : []
            ary.push(parseInt(event.target.value))
            ary = ary.filter(Boolean)
            formData[event.target.name] = ary.join(',')
        } else {
            formData[event.target.name] = formData[event.target.name].split(",").filter((item:any) => parseInt(item) != parseInt(event.target.value)).join(',')

        }

    } else {
        formData[event.target.name] = event.target.value;
    }


    this.props.change_formData(formData);

    if (event.target.name === "cancel_date_start") {
      this.props.get_rent_contracts_list()
    }else{
      this.props.search_rent_contracts_list()
    }
    // if (event.target.name === "section_id") {
    //     this.props.responseList()
    // } else if (event.target.name === "check_end_response" || event.target.name === "check_progress_response") {
    //     // alert(formData[event.target.name])
    //     this.props.responseList()

    // } else if (event.target.name === "condition_radio") {
    //     this.props.responseList()
        
    // } else if (event.target.name === "condition" && Number(event.target.value) === 5) {

    //     this.props.responseList()
    // } else if (event.target.name === "name") {
    //     clearTimeout(timer);
    //     timer = setTimeout(function () {

    //         this.props.search_response_list2()
    //     }.bind(this), 800);

    // } else {
        

    // }
    this.setState({ reflash: !this.state.reflash });

    
}

handleDateChange = (date:any, name:any) => {
  let formData = this.props.formData
  formData[name] = date
  this.props.change_formData(formData);

  if (name === "cancel_date_start") {
    this.props.get_rent_contracts_list()
  }else{
    this.props.search_rent_contracts_list()
  }

  this.setState({ reflash: !this.state.reflash });

};

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div style={{width:200}}>

        <Card style={{ border: 0, boxShadow: "none", textAlign:"left"  }}>
          <CardContent style={{ padding: 5}}>
            <Button size={"small"} variant="contained" color="default" onClick={this.onClear}>条件クリア</Button>
            <Button style={{ backgroundColor: "#5cb85c", float: "right" }} size="small" variant="contained" color="primary">
              <CSVLink style={{textDecoration:"none", color:"white" }} headers={headers} filename={"駐車場リスト.csv"} data={this.props.rent_contracts_list}>CSV</CSVLink>
            </Button>
          </CardContent>
          <CardContent style={{ padding: 5, clear:"both"}}>
            <InputLabel id="sectionId-label" style={{marginBottom:0}}>賃貸革命登録</InputLabel>
            <FormControlLabel control={<Checkbox checked={this.props.formData.chinkaku_mi} name="chinkaku_mi" onChange={this.handleChange} />} label="未" />
            <FormControlLabel control={<Checkbox checked={this.props.formData.chinkaku_zumi} name="chinkaku_zumi" onChange={this.handleChange} />} label="完了" />
            <FormControlLabel control={<Checkbox style={{paddingTop:0, paddingBottom:0}} checked={this.props.formData.chinkaku_zumi_henkou} name="chinkaku_zumi_henkou" onChange={this.handleChange} />} label="変更内容あり" />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="契約者名"
              variant="outlined"
              onChange={this.handleChange}
              name="contractor_name1"
              value={this.props.formData.contractor_name1}
              margin="dense"
            />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="物件名"
              variant="outlined"
              onChange={this.handleChange}
              name="building_name"
              value={this.props.formData.building_name}
              margin="dense"
            />
          </CardContent>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
          <CardContent style={{ padding: 5, marginBottom:10 }}>
          
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="申込日 開始"
              style={{ float: "left", marginTop: "0" }}
              name="application_date_start"
              value={this.props.formData.application_date_start}
              onChange={(e)=>this.handleDateChange(e, "application_date_start")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="申込日 終了"
              style={{ float: "left", marginTop: "0", marginBottom:20 }}
              name="application_date_end"
              value={this.props.formData.application_date_end}
              onChange={(e)=>this.handleDateChange(e, "application_date_end")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
          </CardContent>

          <CardContent style={{ padding: 5, marginBottom:10 }}>
          <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="契約日 開始"
              style={{ float: "left", marginTop: "0" }}
              name="contract_date_start"
              value={this.props.formData.contract_date_start}
              onChange={(e)=>this.handleDateChange(e, "contract_date_start")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="契約日 終了"
              style={{ float: "left", marginTop: "0", marginBottom:20 }}
              name="contract_date_end"
              value={this.props.formData.contract_date_end}
              onChange={(e)=>this.handleDateChange(e, "contract_date_end")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            
          </CardContent>

          <CardContent style={{ padding: 5, marginBottom:10 }}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="締結日 開始"
              style={{ float: "left", marginTop: "0" }}
              name="cloudsign_completed_at_start"
              value={this.props.formData.cloudsign_completed_at_start}
              onChange={(e)=>this.handleDateChange(e, "cloudsign_completed_at_start")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="締結日 終了"
              style={{ float: "left", marginTop: "0", marginBottom:20 }}
              name="cloudsign_completed_at_end"
              value={this.props.formData.cloudsign_completed_at_end}
              onChange={(e)=>this.handleDateChange(e, "cloudsign_completed_at_end")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払区分</InputLabel>
              <Select
                margin="dense"
                id="payment_type"
                name="payment_type"
                value={this.props.formData.payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.payment_type.length > 0 ? this.props.formData.payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={0}><Checkbox checked={this.props.formData.payment_type.indexOf(0) > -1} /><ListItemText primary={"　"} /></MenuItem>
                <MenuItem value={1}><Checkbox checked={this.props.formData.payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払予定区分</InputLabel>
              <Select
                margin="dense"
                id="apply_payment_type"
                name="apply_payment_type"
                value={this.props.formData.apply_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.apply_payment_type.length > 0 ? this.props.formData.apply_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">月々支払区分</InputLabel>
              <Select
                margin="dense"
                id="month_payment_type"
                name="month_payment_type"
                value={this.props.formData.month_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.month_payment_type.length > 0 ? this.props.formData.month_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.formData.month_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.month_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.month_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5, marginTop:10 }}>
          <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="キャンセル日 開始"
              style={{ float: "left", marginTop: "0" }}
              name="cancel_date_start"
              value={this.props.formData.cancel_date_start}
              onChange={(e)=>this.handleDateChange(e, "cancel_date_start")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="キャンセル日 終了"
              style={{ float: "left", marginTop: "0", marginBottom:20 }}
              name="cancel_date_end"
              value={this.props.formData.cancel_date_end}
              onChange={(e)=>this.handleDateChange(e, "cancel_date_end")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
          </CardContent>
          <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.formData.cancel_only} name="cancel_only" onChange={this.handleChange} />} label="キャンセルのみ" />
          </CardContent>
          </MuiPickersUtilsProvider>
        </Card>

        <table>

          <tbody>




            {/* <tr >
              <th>お客様名：</th>
              <td >
                <TextField
                  name="name"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_name}
                  className="form-control"
                />

              </td>
              <th>物件名：</th>
              <td >
                <TextField
                  name="tatemonoName"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_tatemono_name}
                  className="form-control"
                />

              </td>
              <td>
                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={this.props.get_rent_contracts}
                  className="btn btn-primary float-right"
                >検索</button>
              </td>
            </tr>
            <tr >
              <th>契約日：</th>
              <td colSpan={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="contractDataStart"
                    //    onChange={this.handleContractionDateChangeStart}
                    value={this.props.search_contract_date_start}
                    //    value={this.props.estimateData.contractDate}
                    onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
           ～
           <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "20px" }}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="contractDataEnd"
                    value={this.props.search_contract_date_end}
                    // //  value={this.props.estimateData.applicationDate}
                    onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>




              </td>

            </tr > */}
          </tbody>
        </table>








      </div>
    );
  }
}




const mapStateToProps = (state: any) => {
  return {
    formData: state.OfficeContracts.formData,
    rent_contracts_list: state.OfficeContracts.rent_contracts_list,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    change_formData(state: any) {
      dispatch(OfficeContracts.change_formData(state))
    },
    search_rent_contracts_list(state: any) {
      dispatch(OfficeContracts.search_rent_contracts_list(state))
    },
    get_rent_contracts_list(state: any) {
      dispatch(OfficeContracts.get_rent_contracts_list(state))
  },
    // change_search_name(state: any) {
    //   dispatch(OfficeContracts.change_search_name(state))
    // },
    // change_search_contract_date_start(state: any) {
    //   dispatch(OfficeContracts.change_search_contract_date_start(state))
    // },
    // change_search_contract_date_end(state: any) {
    //   dispatch(OfficeContracts.change_search_contract_date_end(state))
    // },
    // change_search_tatemono_name(state: any) {
    //   dispatch(OfficeContracts.change_search_tatemono_name(state))
    // },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

